"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Stroke = exports.stretch = void 0;
function stretch(dp, sp, p, min, max) {
    var p1;
    var p2;
    var p3;
    var p4;
    if (p < sp + 100) {
        p1 = min;
        p3 = min;
        p2 = sp + 100;
        p4 = dp + 100;
    }
    else {
        p1 = sp + 100;
        p3 = dp + 100;
        p2 = max;
        p4 = max;
    }
    return Math.floor(((p - p1) / (p2 - p1)) * (p4 - p3) + p3);
}
exports.stretch = stretch;
var Stroke = /** @class */ (function () {
    function Stroke(data) {
        this.a1 = data[0], this.a2_100 = data[1], this.a3_100 = data[2], this.x1 = data[3], this.y1 = data[4], this.x2 = data[5], this.y2 = data[6], this.x3 = data[7], this.y3 = data[8], this.x4 = data[9], this.y4 = data[10];
        this.kirikuchiAdjustment = Math.floor(this.a2_100 / 100) % 10;
        this.tateAdjustment = Math.floor(this.a2_100 / 1000) % 10;
        this.opt3 = Math.floor(this.a2_100 / 10000);
        this.a2_100 %= 100;
        this.haneAdjustment = this.urokoAdjustment = this.kakatoAdjustment = Math.floor(this.a3_100 / 100) % 10;
        this.mageAdjustment = Math.floor(this.a3_100 / 1000);
        this.a3_100 %= 100;
    }
    Stroke.prototype.getControlSegments = function () {
        var res = [];
        switch (this.a1) {
            case 0:
            case 8:
            case 9:
                break;
            case 6:
            case 7:
                res.unshift([this.x3, this.y3, this.x4, this.y4]);
            // falls through
            case 2:
            case 12:
            case 3:
            case 4:
                res.unshift([this.x2, this.y2, this.x3, this.y3]);
            // falls through
            default:
                res.unshift([this.x1, this.y1, this.x2, this.y2]);
        }
        return res;
    };
    Stroke.prototype.stretch = function (sx, sx2, sy, sy2, bminX, bmaxX, bminY, bmaxY) {
        this.x1 = stretch(sx, sx2, this.x1, bminX, bmaxX);
        this.y1 = stretch(sy, sy2, this.y1, bminY, bmaxY);
        this.x2 = stretch(sx, sx2, this.x2, bminX, bmaxX);
        this.y2 = stretch(sy, sy2, this.y2, bminY, bmaxY);
        if (this.a1 !== 99) { // always true
            this.x3 = stretch(sx, sx2, this.x3, bminX, bmaxX);
            this.y3 = stretch(sy, sy2, this.y3, bminY, bmaxY);
            this.x4 = stretch(sx, sx2, this.x4, bminX, bmaxX);
            this.y4 = stretch(sy, sy2, this.y4, bminY, bmaxY);
        }
    };
    Stroke.prototype.getBox = function () {
        var minX = Infinity;
        var minY = Infinity;
        var maxX = -Infinity;
        var maxY = -Infinity;
        switch (this.a1) {
            default:
                minX = Math.min(minX, this.x4);
                maxX = Math.max(maxX, this.x4);
                minY = Math.min(minY, this.y4);
                maxY = Math.max(maxY, this.y4);
            // falls through
            case 2:
            case 3:
            case 4:
                minX = Math.min(minX, this.x3);
                maxX = Math.max(maxX, this.x3);
                minY = Math.min(minY, this.y3);
                maxY = Math.max(maxY, this.y3);
            // falls through
            case 1:
            case 99: // unnecessary?
                minX = Math.min(minX, this.x1, this.x2);
                maxX = Math.max(maxX, this.x1, this.x2);
                minY = Math.min(minY, this.y1, this.y2);
                maxY = Math.max(maxY, this.y1, this.y2);
            // falls through
            case 0:
        }
        return { minX: minX, maxX: maxX, minY: minY, maxY: maxY };
    };
    return Stroke;
}());
exports.Stroke = Stroke;
